export const personalInfo = {
  name: '岳俊',
  nameEn: 'Yue Jun',
  title: 'AI 产品经理',
  subtitle: 'AI Product Manager',
  tagline: '深耕 AI 智能体赛道，将非结构化数据转化为业务价值，构建真正懂业务的 AI 产品',
  bio: '拥有 2 年 AI 产品经理经验，专注于大模型应用与智能体产品的从 0 到 1 落地。深度参与教育、医疗、政务、金融、央企审计等多个垂直领域的 AI 智能体产品设计与实施，擅长非结构化与结构化数据的融合处理，打造深度融合业务的智能体平台。',
  location: '北京，中国',
  email: 'yuejun2413@gmail.com',
  phone: '',
  wechat: 'Syovo668',
  available: true,
  experience: '2年+',
  projects: '6+',
  users: '多行业',
  avatar: 'https://public.readdy.ai/ai/img_res/b79c9c969a90e53a37622098c962da79.jpg',
  heroImage: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20neural%20network%20brain%20visualization%20with%20glowing%20interconnected%20nodes%20and%20data%20streams%2C%20abstract%20digital%20intelligence%20concept%2C%20deep%20orange%20and%20amber%20gradient%20on%20dark%20background%2C%20cinematic%20lighting%2C%20sci-fi%20technology%20art%2C%20professional%20hero%20illustration%2C%20holographic%20effect%20with%20circuit%20patterns&width=640&height=720&seq=hero_ai_visual_002&orientation=portrait',
};

export const skills = [
  'AI 智能体产品设计', '大模型应用落地', 'RAG 知识库',
  'Dify', 'Coze', 'RAGFlow',
  'FastAPI', 'Python', 'Vibe Coding',
  'Prompt Engineering', '数据分析', '产品战略规划',
  '需求管理', '用户研究', 'PRD 撰写', 'Agile/Scrum',
];

// 排列顺序：第一行 1+3，第二行 4+6，第三行 2+5（医者AI 与 央企审计 对齐）
export const projects = [
  {
    id: 1,
    title: '简单学习网 AI 答疑助手',
    titleEn: 'AI Q&A Assistant for Jiandan Learning',
    category: '教育 AI · 智能答疑',
    description: '为简单学习网打造的 AI 智能答疑系统，基于大语言模型与 RAG 知识库，支持多学科题目解析与个性化学习路径推荐，精准理解学生意图，大幅降低人工答疑成本。',
    tags: ['LLM', 'RAG', '教育 AI', '知识库'],
    color: 'from-orange-500 to-rose-500',
    image: 'https://readdy.ai/api/search-image?query=modern%20AI%20education%20platform%20interface%2C%20student%20asking%20questions%20to%20AI%20chatbot%2C%20clean%20minimal%20UI%20with%20warm%20orange%20tones%2C%20knowledge%20graph%20visualization%2C%20math%20and%20science%20subject%20icons%2C%20professional%20product%20screenshot%20style%2C%20soft%20warm%20background&width=600&height=400&seq=proj_edu_001&orientation=landscape',
    metrics: ['多学科覆盖', '答疑准确率 90%+', '人工成本降低 70%'],
    year: '2024',
  },
  {
    id: 3,
    title: '国资委内控监督智能体',
    titleEn: 'SASAC Internal Control Supervision Agent',
    category: '政务 AI · 合规监督',
    description: '面向国有资产监督管理委员会打造的内控合规监督智能体，自动解析政策法规与内控文件，实现风险点智能识别、合规检查辅助与问题自动归档，提升国资监管效能。',
    tags: ['政务 AI', '合规监督', '文档解析', '风险识别'],
    color: 'from-rose-500 to-pink-600',
    image: 'https://readdy.ai/api/search-image?query=government%20compliance%20monitoring%20dashboard%2C%20internal%20control%20audit%20interface%2C%20clean%20professional%20enterprise%20UI%20with%20document%20analysis%20visualization%2C%20risk%20assessment%20charts%2C%20warm%20neutral%20tone%20design%2C%20authoritative%20and%20trustworthy%20government%20tech%20product&width=600&height=400&seq=proj_gov_001&orientation=landscape',
    metrics: ['政策法规自动解析', '风险智能识别', '监管效能提升'],
    year: '2024',
  },
  {
    id: 4,
    title: '招投标风险审查智能体',
    titleEn: 'Bidding Risk Review Agent',
    category: '金融 AI · 风险合规',
    description: '专为招投标场景设计的 AI 风险审查智能体，自动抽取并解析招标文件关键条款，识别潜在风险项与合规缺口，生成结构化审查报告，显著提升投标质量与合规管控能力。',
    tags: ['风险审查', '文档智能', 'AI 合规', '招投标'],
    color: 'from-stone-600 to-gray-700',
    image: 'https://readdy.ai/api/search-image?query=contract%20risk%20analysis%20AI%20platform%20interface%2C%20document%20review%20and%20compliance%20checking%20dashboard%2C%20professional%20enterprise%20design%20with%20risk%20scoring%20visualization%2C%20warm%20amber%20and%20cream%20tones%2C%20legal%20tech%20product%20screenshot%2C%20clean%20and%20authoritative%20design&width=600&height=400&seq=proj_bid_001&orientation=landscape',
    metrics: ['文件自动解析', '风险条款识别', '审查效率提升 80%'],
    year: '2023',
  },
  {
    id: 6,
    title: '数智一体智能体平台',
    titleEn: 'DataAI Integrated Agent Platform',
    category: '平台产品 · 智能体 PaaS',
    description: '对标 Coze、Dify 的自研智能体平台，深度融合业务场景，具备超强的非结构化与结构化数据处理能力，支持多模态数据接入、自定义工作流编排与一键行业部署，让企业 AI 落地更快更深。',
    tags: ['智能体平台', 'PaaS', '非结构化数据', '工作流编排'],
    color: 'from-orange-600 to-amber-500',
    image: 'https://readdy.ai/api/search-image?query=enterprise%20AI%20agent%20platform%20interface%2C%20workflow%20orchestration%20canvas%20with%20connected%20nodes%2C%20multi-modal%20data%20processing%20visualization%2C%20warm%20orange%20gradient%20UI%2C%20low-code%20platform%20design%2C%20professional%20SaaS%20product%20screenshot%2C%20clean%20modern%20dashboard%20with%20agent%20building%20tools&width=600&height=400&seq=proj_platform_001&orientation=landscape',
    metrics: ['对标 Coze/Dify', '非结构化数据处理超强', '多行业快速部署'],
    year: '2024',
  },
  {
    id: 2,
    title: '医者 AI · 口腔私域增长引擎',
    titleEn: 'Yizhe AI - Dental Private Domain Growth Engine',
    category: '医疗 AI · 私域增长',
    description: '面向口腔医疗机构的 AI 私域增长引擎，集"金牌AI员工 + AI私域运营专家 + 员工AI提效精灵 + 门店AI经营参谋"四大角色于一体。7×24h 全时沟通促成到店，深度行业话术训练与情绪安抚；智能热点探测与种草内容一键生成；员工话术 AI 训练与接待质量评价；门店会话数据实时洞察，协同提升经营决策效能，驱动私域全链路增长闭环。',
    tags: ['医疗 AI', '私域运营', '智能体', '多角色 AI'],
    color: 'from-amber-500 to-orange-600',
    image: 'https://readdy.ai/api/search-image?query=dental%20clinic%20AI%20private%20domain%20marketing%20platform%2C%20multi-role%20AI%20assistant%20dashboard%20interface%2C%20chat%20automation%20and%20marketing%20content%20generation%20UI%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20healthcare%20tech%20product%2C%20professional%20mobile%20and%20desktop%20interface%20design%2C%20growth%20analytics%20visualization&width=600&height=400&seq=proj_dental_002&orientation=landscape',
    metrics: ['7×24h 全时沟通', '私域营销自动化', '员工 AI 提效', '门店经营参谋'],
    year: '2024',
  },
  {
    id: 5,
    title: '央企审计智能体',
    titleEn: 'Central SOE Audit Intelligence Agent',
    category: '央企 AI · 智能审计',
    description: '面向央企集团的智能审计解决方案，分两大核心模块：① 审计意图空间——对数据中台治理资产进行学习、标注与理解，通过大模型实现数据知识与业务知识融合，构建企业专属审计意图知识图谱；② 审计规则库扩充——整合审计指南、规章制度、案例与问题库，由大模型泛化生成规则草稿，经专家校核归集规则库，驱动各审计监督智能体完成智能化闭环，持续迭代维持规则库时效性。',
    tags: ['央企审计', '意图空间', '知识图谱', 'LLM 规则生成'],
    color: 'from-red-700 to-rose-600',
    image: 'https://readdy.ai/api/search-image?query=enterprise%20audit%20intelligence%20platform%2C%20knowledge%20graph%20visualization%20with%20interconnected%20audit%20rules%20and%20business%20data%20nodes%2C%20professional%20dark%20themed%20dashboard%20with%20orange%20accent%20colors%2C%20state-owned%20enterprise%20compliance%20monitoring%20interface%2C%20data%20governance%20asset%20analysis%20visualization%2C%20authoritative%20and%20sophisticated%20design&width=600&height=400&seq=proj_audit_soe_001&orientation=landscape',
    metrics: ['审计意图空间构建', '大模型规则泛化生成', '专家校核闭环', '规则库持续迭代'],
    year: '2025',
  },
];

export const blogPosts = [
  {
    id: 1,
    title: '智能体产品落地的核心挑战：从通用到垂直的跨越',
    category: 'AI 产品思考',
    excerpt: '通用智能体平台（如 Coze、Dify）解决了工具层问题，但真正的业务价值在于垂直场景的深度融合。本文分享从多个行业落地中总结的关键方法论……',
    date: '2025-02-18',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=AI%20agent%20technology%20concept%20illustration%2C%20interconnected%20neural%20nodes%20forming%20industry%20specific%20applications%2C%20warm%20orange%20gradient%20abstract%20background%2C%20minimalist%20digital%20art%2C%20technology%20insight%20blog%20header%2C%20professional%20and%20modern&width=600&height=380&seq=blog_yj_001&orientation=landscape',
    tags: ['智能体', 'AI 落地', '垂直行业'],
  },
  {
    id: 2,
    title: '非结构化数据处理：AI 产品的核心竞争壁垒',
    category: '技术洞察',
    excerpt: '企业内 80% 以上的数据是非结构化的——PDF 文档、音视频、图片等。如何让 AI 真正"读懂"这些数据，是 AI 产品经理最需要深入理解的技术战场……',
    date: '2025-01-10',
    readTime: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=unstructured%20data%20processing%20visualization%2C%20documents%20images%20and%20audio%20being%20analyzed%20by%20AI%2C%20abstract%20data%20flow%20illustration%2C%20warm%20amber%20tones%2C%20modern%20minimalist%20technology%20concept%20art%2C%20knowledge%20extraction%20visual%20metaphor&width=600&height=380&seq=blog_yj_002&orientation=landscape',
    tags: ['非结构化数据', 'RAG', '产品壁垒'],
  },
  {
    id: 3,
    title: '医疗 AI 产品设计：合规与体验的双重平衡',
    category: '产品方法论',
    excerpt: '医疗是 AI 落地难度最高的行业之一。从口腔智能体的产品设计中，我总结了在严格合规约束下打造良好用户体验的五个核心原则……',
    date: '2024-11-25',
    readTime: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=healthcare%20AI%20product%20design%20concept%2C%20medical%20app%20interface%20wireframes%2C%20clean%20minimal%20design%20with%20soft%20medical%20tones%2C%20patient%20experience%20and%20compliance%20balance%20illustration%2C%20warm%20white%20and%20mint%20colors%2C%20professional%20medical%20tech%20blog%20header&width=600&height=380&seq=blog_yj_003&orientation=landscape',
    tags: ['医疗 AI', '产品设计', '合规'],
  },
  {
    id: 4,
    title: '政务 AI 产品的需求挖掘：如何与甲方"同频"',
    category: '产品实战',
    excerpt: '政府类客户的需求表达与互联网产品截然不同，充满隐性约束与流程壁垒。本文结合国资委项目经历，分享政务场景下 AI 产品需求挖掘的实战心得……',
    date: '2024-09-08',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=government%20enterprise%20product%20requirements%20workshop%20illustration%2C%20professional%20meeting%20with%20stakeholders%2C%20whiteboard%20with%20user%20journey%20mapping%2C%20warm%20neutral%20tones%2C%20business%20analysis%20concept%20art%2C%20minimalist%20clean%20style%20blog%20header&width=600&height=380&seq=blog_yj_004&orientation=landscape',
    tags: ['政务 AI', '需求管理', '产品实战'],
  },
  {
    id: 5,
    title: '数据分析驱动 AI 产品决策：从埋点设计到洞察落地',
    category: '数据与 AI',
    excerpt: '好的 AI 产品不能只靠直觉迭代，数据分析是连接用户行为与产品决策的桥梁。本文分享如何构建 AI 产品的数据体系——从埋点设计、漏斗分析到大模型输出质量评估，让每一次迭代都有据可依……',
    date: '2025-03-10',
    readTime: '11 分钟',
    image: 'https://readdy.ai/api/search-image?query=data%20analytics%20dashboard%20for%20AI%20product%20management%2C%20funnel%20analysis%20charts%20and%20user%20behavior%20heatmap%20visualization%2C%20clean%20modern%20BI%20interface%20with%20warm%20orange%20accent%20colors%2C%20data-driven%20decision%20making%20concept%20illustration%2C%20professional%20product%20analytics%20blog%20header%2C%20minimal%20and%20sophisticated%20design&width=600&height=380&seq=blog_yj_005&orientation=landscape',
    tags: ['数据分析', 'AI 产品', '增长'],
  },
  {
    id: 6,
    title: 'Prompt Engineering 进阶：让大模型输出更可控',
    category: '技术洞察',
    excerpt: '从 zero-shot 到 chain-of-thought，Prompt 工程直接决定大模型在业务场景中的落地质量。本文系统梳理常用提示词技巧，并结合智能体项目中的真实调优案例，帮助 PM 建立对 LLM 输出的掌控力……',
    date: '2025-01-28',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=prompt%20engineering%20visualization%2C%20large%20language%20model%20interaction%20diagram%20with%20chain%20of%20thought%20reasoning%2C%20abstract%20text%20flow%20and%20AI%20response%20optimization%20concept%2C%20warm%20cream%20and%20orange%20tones%2C%20clean%20minimalist%20tech%20illustration%2C%20professional%20blog%20header%20for%20AI%20engineering&width=600&height=380&seq=blog_yj_006&orientation=landscape',
    tags: ['Prompt Engineering', 'LLM', '智能体'],
  },
];

export const socialLinks = [
  { name: 'GitHub', icon: 'ri-github-line', url: 'https://github.com' },
  { name: 'LinkedIn', icon: 'ri-linkedin-line', url: 'https://linkedin.com' },
  { name: 'WeChat', icon: 'ri-wechat-line', url: '#contact' },
  { name: 'Email', icon: 'ri-mail-line', url: 'mailto:yuejun2413@gmail.com' },
];

export const searchableItems = [
  { label: '关于我', section: 'about' },
  { label: '项目案例', section: 'projects' },
  { label: '技术博客', section: 'blog' },
  { label: '联系方式', section: 'contact' },
  { label: '简单学习网 AI 答疑助手', section: 'projects' },
  { label: '医者 AI 口腔私域增长引擎', section: 'projects' },
  { label: '国资委内控监督智能体', section: 'projects' },
  { label: '招投标风险审查智能体', section: 'projects' },
  { label: '央企审计智能体', section: 'projects' },
  { label: '数智一体智能体平台', section: 'projects' },
  { label: '智能体产品落地垂直行业', section: 'blog' },
  { label: '非结构化数据处理', section: 'blog' },
  { label: '医疗 AI 产品设计', section: 'blog' },
  { label: '政务 AI 需求挖掘', section: 'blog' },
  { label: '数据分析 AI 产品决策', section: 'blog' },
  { label: 'Prompt Engineering 进阶', section: 'blog' },
];
